var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2546,
    height: 1492,
    viewBox: "0 0 2546 1492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2533 -3H0V1489H2533V-3Z",
    fill: "#FCF5EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M712.653 636.585L724.093 654.746C748.334 693.223 799.65 704.873 838.128 680.631L932.253 621.335L991.551 715.459C1015.79 753.938 1067.11 765.588 1105.59 741.347L1123.75 729.907C1162.23 705.666 1173.87 654.35 1149.63 615.87L1090.33 521.746L1184.46 462.448C1222.94 438.209 1234.59 386.893 1210.35 348.414L1198.91 330.254C1196.68 326.719 1194.16 323.492 1191.5 320.417L1117.92 292.506C1106.5 294.008 1095.22 297.85 1084.87 304.366L990.747 363.664L931.449 269.538C907.209 231.062 855.893 219.412 817.415 243.653L799.254 255.093C760.776 279.334 749.126 330.65 773.368 369.127L832.664 463.252L738.539 522.551C700.061 546.791 688.413 598.107 712.653 636.585Z",
    fill: "#F7EDDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697.967 1316.55C553.305 1132.77 860.781 1145.58 868.869 915.281C876.958 684.98 507.201 873.982 507.201 873.982C373.144 922.635 291.667 1044.01 297.272 1100.03C314.557 1272.78 496.031 1235.16 516.384 1361.73C550.932 1576.53 842.626 1500.34 697.967 1316.55Z",
    fill: "#F7EDDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3991 331.78C5.01025 493.673 129.892 632.209 291.78 640.601C453.673 648.991 592.209 524.11 600.601 362.216C608.993 200.326 484.111 61.7914 322.217 53.3993C160.328 45.008 21.7912 169.889 13.3991 331.78Z",
    fill: "#F7EDDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1595.4 1068.78C1587.01 1230.67 1711.89 1369.21 1873.78 1377.6C2035.67 1385.99 2174.21 1261.11 2182.6 1099.22C2190.99 937.326 2066.11 798.791 1904.22 790.399C1742.33 782.008 1603.79 906.89 1595.4 1068.78Z",
    fill: "#F7EDDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.78 89.52C1992.08 85.1361 1985.55 83.3647 1979.31 84.7904C1973.07 86.2128 1967.93 90.6466 1965.55 96.6458L1820.91 461.985L1598.1 232.736C1593.57 228.079 1587.05 225.999 1580.7 227.189C1574.35 228.381 1568.99 232.682 1566.42 238.669L1354.41 731.755L1282.97 694.099C1275.01 690.794 1265.94 691.793 1258.88 696.749C1255.51 699.117 1252.81 702.235 1250.95 705.792C1248.91 709.681 1247.86 714.096 1248.01 718.633L1253.51 1039.26C1253.82 1048.59 1259.13 1057 1267.37 1061.23C1275.6 1065.45 1285.45 1064.81 1293.09 1059.56L1562.07 883.602C1569.78 878.302 1573.98 869.158 1573.01 859.793C1572.05 850.427 1566.07 842.352 1557.45 838.771L1484.59 800.366L1625.65 472.283L1852.73 705.922C1857.33 710.653 1863.98 712.719 1870.41 711.413C1876.84 710.11 1882.19 705.613 1884.63 699.459L2032.96 324.799L2261.93 538.592C2266.36 542.724 2272.43 544.547 2278.37 543.529C2284.31 542.509 2289.45 538.762 2292.27 533.384L2530.73 79.8517C2533.15 75.2531 2533.65 69.8729 2532.15 64.8956C2530.64 59.9191 2527.24 55.7499 2522.69 53.3071L2427.67 2.29903C2418.19 -2.78843 2406.43 0.85005 2401.4 10.4251L2240.27 316.876L1996.78 89.52Z",
    fill: "#F7EDDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2546,
    height: 1492,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouble);
export default __webpack_public_path__ + "static/media/double.0bcdaa6a1d77b7bf91021571ecfc04a2.svg";
export { ForwardRef as ReactComponent };